module.exports = __webpack_public_path__ + "img/masterclass_smartphone.c5046a55.jpg";